<template>
  <aside class="sign-in">
    <header class="window__header">
      <h1 class="window__title" style="text-align: center;">{{ forgotPassword ? "Forgot Password" : "Sign In"}}</h1>
    </header>

    <section class="window__content" v-if="!forgotPassword"  v-on:keyup.enter="submit">
      <p v-if="error" class="message error">{{error}}</p>
      <div class="window__input input input--flow" style="margin-bottom:1em;">
        <input class="input__field" type="email" placeholder="What’s your e-mail address?" v-model="email" />
      </div>

      <div class="window__input input input--flow" style="margin-bottom:1em;">
        <input class="input__field" type="password" placeholder="What's your password?" v-model="password" />
      </div>

      <p style="text-align: center;">
        <a href="#" style="text-align: center;" v-on:click.prevent="toggleForgotPassword">Forgot your password?</a>
      </p>
    </section>

    <section class="window__content" style="padding: 66px 0px;" v-if="forgotPassword"  v-on:keyup.enter="submit">
      <p v-if="error" class="message error">{{error}}</p>
      <div class="window__input input input--flow" style="margin-bottom:1em;">
        <input class="input__field" type="email" placeholder="What’s your e-mail address?" v-model="email" />
      </div>

      <p style="text-align: center;">
        <a href="#" v-on:click.prevent="toggleForgotPassword">Sign in</a>
      </p>
    </section>

    <footer>
      <a href="#" v-on:click.prevent="submit" class="window__button button button--primary button--expand" v-bind:class="{ 'button--disabled': forgotPassword ? !email : (!email || !password) }">
        {{forgotPassword ? "Recover Password" : "Sign In"}}
      </a>

      <span v-on:click.prevent="googleSignIn" class="window__button button button--google--blue button--tertiary button--expand">Sign in With Google</span>
    </footer>
  </aside>
</template>

<script>
//https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/email
import store from '../../store'
import { oauthLogin } from "../../lib/oauth"

export default {
  name: 'SignInModal',
  methods: {
    hide () {
      this.$modal.hide('sign-in')
    },
    submit () {
      this.error = null;
      let { email, password } = this;

      if(this.forgotPassword){
        store.dispatch('users/sendForgotPassword', { email: email,
          callback: () => {
          this.hide();
        }});
      } else {
        store.dispatch('login', {email, password});
      }
    },
    toggleForgotPassword(){
      this.forgotPassword = !this.forgotPassword;
    },
    googleSignIn(e){
      e.preventDefault();
      oauthLogin('google');
    }
  },
  data(){
    let obj = {
      email: '',
      password: '',
      apiError: false,
      validEmail: false,
      forgotPassword: false,
      error: null
    }

    return obj;
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modals/SignIn.vue